var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"main-button",on:{"click":_vm.openCreateContactDialog}},[_vm._v(_vm._s(_vm.$t('Create contact')))])
}
var staticRenderFns = []

export { render, staticRenderFns }